import { Button } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import shareViewLinkIllustration from "../../assets/images/shareViewLinkIllustration.webp";
import { CollaborationPromoURL } from "../../config";
import { useTracker } from "../../hooks/useTracker";
import useTranslation from "../../hooks/useTranslation";

import style from "./CollaborationPromo.module.css";

export const CollaborationPromo = () => {
  const tracker = useTracker();
  const { t, m } = useTranslation();
  const { teamID } = useParams();

  return (
    <div className={style.pageContainer}>
      <div className={style.promoContainer}>
        <img
          src={shareViewLinkIllustration}
          alt={t(m.CollaborationPromo.IllustrationAlt)}
          className={style.illustration}
        />
        <div className={style.title}>{t(m.CollaborationPromo.Title)}</div>
        <div className={style.subtitle}>{t(m.CollaborationPromo.Subtitle)}</div>
        <Button
          variant="grayscale"
          onClick={() => {
            tracker.trackGoToCollaborationPromo({
              activeTeamId: teamID,
              location: "review_links",
            });
            window.open(CollaborationPromoURL);
          }}
        >
          {t(m.CollaborationPromo.LearnMoreHow)}
        </Button>
      </div>
    </div>
  );
};
